/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request for an dayModel
 * @export
 * @interface DayModelResquest
 */
export interface DayModelResquest {
    /**
     * Name of dayModel
     * @type {string}
     * @memberof DayModelResquest
     */
    name?: string;
}

/**
 * Check if a given object implements the DayModelResquest interface.
 */
export function instanceOfDayModelResquest(value: object): value is DayModelResquest {
    return true;
}

export function DayModelResquestFromJSON(json: any): DayModelResquest {
    return DayModelResquestFromJSONTyped(json, false);
}

export function DayModelResquestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DayModelResquest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function DayModelResquestToJSON(json: any): DayModelResquest {
    return DayModelResquestToJSONTyped(json, false);
}

export function DayModelResquestToJSONTyped(value?: DayModelResquest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

